<template>
    <div id="body-wrap" class="">
        <LayoutHeader />
        <Intro />
        <Footer />
        <FooterPc />
        <Common />
    </div>
</template>

<script>
import LayoutHeader from '@/views/layout/LayoutHeader.vue';
import Footer from "@/views/layout/Footer";
import FooterPc from "@/views/layout/FooterPc";
import Intro from '@/views/intro/Intro.vue';
import Common from '@/views/common/Common.vue';

import { defualtMeta } from '@/confs/vue.meta';

export default {
    metaInfo: {
        meta: defualtMeta,
    },
    components: {
        LayoutHeader,
        Footer,
        FooterPc,
        Intro,
        Common,
    },

    computed: {
    },
    created() {
        this.$store.dispatch('FETCH_VIDEO_INFO');
    },
    methods: {

    },
};
</script>
